import type { GetPlatformV1AuditLogsParams } from '@nucleus-commerce/api-client/platform';

import type { AuditLogFilterForm, AuditLogSearch } from '../schemas/audit-log-search';

const DAY_MS = 86_400_000;

function nextDay(day: string): string {
  return new Date(Date.parse(`${day}T00:00:00.000Z`) + DAY_MS).toISOString();
}

/** URL search → API filters. `to` is inclusive in the URL and exclusive in the API. */
export function auditLogParams(search: AuditLogSearch): GetPlatformV1AuditLogsParams {
  return {
    ...(search.organizationId ? { organizationId: search.organizationId } : {}),
    ...(search.actorType ? { actorType: search.actorType } : {}),
    ...(search.action ? { action: search.action } : {}),
    ...(search.entityType ? { entityType: search.entityType } : {}),
    ...(search.from ? { from: `${search.from}T00:00:00.000Z` } : {}),
    ...(search.to ? { to: nextDay(search.to) } : {}),
  };
}

export function filterFormFor(search: AuditLogSearch): AuditLogFilterForm {
  return {
    organizationId: search.organizationId ?? '',
    actorType: search.actorType ?? '',
    action: search.action ?? '',
    entityType: search.entityType ?? '',
    from: search.from ?? '',
    to: search.to ?? '',
  };
}

/** Form → URL search; blanks drop out so the URL stays short. */
export function searchFromFilterForm(values: AuditLogFilterForm): Record<string, string> {
  return Object.fromEntries(
    Object.entries(values)
      .map(([key, value]) => [key, value.trim()] as const)
      .filter(([, value]) => value !== ''),
  );
}
